import './empty-message.styles.scss';

const EmptyMessage: React.FC = (props) => {
  return <p className="empty-message">{props.children}</p>;
};

export default EmptyMessage;
